import queryString from 'query-string';
import urlJoin from 'url-join';

export const configToUrlQuery = ({
    pinId, year, month, day,
}) => {
    // const baseUrl = `https://visualization.bike${location.pathname}`;
    // return urlJoin(baseUrl, `?${queryString.stringify({pinId: JSON.stringify(pinId), year, month, day})}`);
};

export const stringifyPinId = pinId => queryString.stringify({ pinId: JSON.stringify(pinId) });

export const getTripCurrentDate = (year, month, day) => `${year}_${month}_${day}`;

export const tripFulldateToYYMMDD = (fulldate) => {
    const date = fulldate.split('_');
    return { year: date[0], month: date[1], day: date[2] };
};

export const getPinColor = (index) => {
    const pinColorList = [
        '#2CCCE4',
        '#FFEB3B',
        '#FF8A65',
        '#E0E0E0',
        '#39CCCC',
        '#F012BE',
        '#2ECC40',
        '#B5FFE1',
        '#DBC2CF',
        '#795548',
    ];
    const colorIndex = index % pinColorList.length;
    return pinColorList[colorIndex];
};

export const getActivitySepTime = (time) => {
    const dateTime = new Date(time * 1000);
    const yy = dateTime.getUTCFullYear();
    const mm = dateTime.getUTCMonth();
    const dd = dateTime.getUTCDate();
    const hh = dateTime.getUTCHours();
    return Date.UTC(yy, mm, dd, hh) / 1000;
};

const unifyGeo = geo => geo / 1000000;

export const getRealGeoFromRounded = (centerMulti1000000, geo) => [
    unifyGeo(centerMulti1000000[0] - geo[0]),
    unifyGeo(centerMulti1000000[1] - geo[1]),
];
